module.exports = __webpack_public_path__ + "img/restaurant_3.bbb96069.jpg";